"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./styles.css");
var ArrowIcon = function () { return (react_1.default.createElement("div", { className: (0, classnames_1.default)('dui-icon-container', 'centered') },
    react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "19", height: "16", viewBox: "0 0 19 16", fill: "none" },
        react_1.default.createElement("path", { fill: 'var(--navbar-icons)', d: "M10.303 15.8894L8.94081 14.5416L14.5763 8.92003H0.016949L0.021785 6.96933L14.5812 6.96933L8.97347 1.36549L10.3424 0L18.2674 7.94468L10.303 15.8894Z" })))); };
exports.default = ArrowIcon;
